import { TMealFormData } from "@/types/mealType";
import Image from "next/image";
import Link from "next/link";
import { FaCheckCircle, FaLeaf, FaTimesCircle } from "react-icons/fa";
import { MdOutlineFastfood } from "react-icons/md";
import { TbCurrencyTaka } from "react-icons/tb";
import { GiForkKnifeSpoon } from "react-icons/gi";

const MealCard = ({ meal }: { meal: TMealFormData }) => {
  return (
    <section className="p-4 rounded-2xl bg-gray-200 dark:bg-gray-800 shadow-md flex flex-col gap-4">
      <div className="flex justify-center group">
        <Image
          src={meal?.imageUrl || "/default.jpg"}
          alt={meal?.title || "Meal Image"}
          height={700}
          width={700}
          className="w-52 h-52 border-4 border-secondary 
                 rounded-full transition-all duration-500 hover:w-[66vw] ease-in-out group-hover:rounded-xl"
        />
      </div>

      <div className="grid grid-cols-2 gap-4 text-sm">
        <div className="flex items-center gap-2 px-3 py-1 bg-secondary dark:bg-blue-800 text-primary dark:text-blue-100 rounded-full shadow-sm">
          <MdOutlineFastfood className="text-base" />
          <span className="font-medium capitalize">{meal?.cuisineType}</span>
        </div>
        <div className="flex items-center gap-2 px-3 py-1 bg-primary dark:bg-green-500 text-secondary dark:text-green-900 rounded-full shadow-sm">
          <GiForkKnifeSpoon className="text-base" />
          <span className="font-medium capitalize">{meal?.foodCategory}</span>
        </div>

        <div className="flex items-center gap-2 px-3 py-1 bg-green-100 dark:bg-green-800 text-green-800 dark:text-green-100 rounded-full shadow-sm">
          <FaLeaf className="text-base" />
          <span className="font-medium capitalize">{meal?.foodPreference}</span>
        </div>
        {meal?.isAvailable && (
          <div
            className={`flex items-center gap-2 px-3 py-1 rounded-full shadow-sm ${
              meal?.isAvailable
                ? "bg-green-100 dark:bg-green-800 text-green-800 dark:text-green-100"
                : "bg-red-100 dark:bg-red-800 text-red-800 dark:text-red-100"
            }`}
          >
            {meal?.isAvailable ? (
              <FaCheckCircle className="text-base" />
            ) : (
              <FaTimesCircle className="text-base" />
            )}
            <span className="font-medium capitalize">
              {meal?.isAvailable ? "Available" : "Unavailable"}
            </span>
          </div>
        )}
      </div>
      {meal?.avarageRating !== undefined && meal?.ratingCount !== undefined && (
        <p className="text-lg font-bold text-gray-800 dark:text-gray-200 ">
          Rating:{" "}
          <span className="bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-100 px-3 py-1 rounded-full">
            {meal?.avarageRating?.toFixed(1)} ★ ({meal.ratingCount}{" "}
            {meal.ratingCount === 1 ? "person has rated" : "people have rated"})
          </span>
        </p>
      )}
      <hr className="border border-primary" />

      <h2 className="text-2xl font-bold text-gray-800 dark:text-white flex-grow">
        {meal?.title}
      </h2>

      <div className="flex items-center justify-between">
        <span className="flex items-center gap-1 text-primary dark:text-secondary font-bold text-xl">
          <TbCurrencyTaka className="text-xl" />
          {meal?.price}
        </span>
        <Link
          href={`/meals/${meal?._id}`}
          className="bg-secondary text-primary border border-primary px-4 py-2 rounded-xl font-medium hover:bg-primary hover:border-secondary hover:text-secondary transition-all duration-500"
        >
          View Details
        </Link>
      </div>
    </section>
  );
};

export default MealCard;
